function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Split this component for RSC import
 */
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var DEFAULT_MODE_STORAGE_KEY = 'mode';
export var DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
export var DEFAULT_ATTRIBUTE = 'data-color-scheme';
export default function InitColorSchemeScript(options) {
  var _ref = options || {},
    _ref$defaultLightColo = _ref.defaultLightColorScheme,
    defaultLightColorScheme = _ref$defaultLightColo === void 0 ? 'light' : _ref$defaultLightColo,
    _ref$defaultDarkColor = _ref.defaultDarkColorScheme,
    defaultDarkColorScheme = _ref$defaultDarkColor === void 0 ? 'dark' : _ref$defaultDarkColor,
    _ref$modeStorageKey = _ref.modeStorageKey,
    modeStorageKey = _ref$modeStorageKey === void 0 ? DEFAULT_MODE_STORAGE_KEY : _ref$modeStorageKey,
    _ref$colorSchemeStora = _ref.colorSchemeStorageKey,
    colorSchemeStorageKey = _ref$colorSchemeStora === void 0 ? DEFAULT_COLOR_SCHEME_STORAGE_KEY : _ref$colorSchemeStora,
    _ref$attribute = _ref.attribute,
    initialAttribute = _ref$attribute === void 0 ? DEFAULT_ATTRIBUTE : _ref$attribute,
    _ref$colorSchemeNode = _ref.colorSchemeNode,
    colorSchemeNode = _ref$colorSchemeNode === void 0 ? 'document.documentElement' : _ref$colorSchemeNode,
    nonce = _ref.nonce;
  var setter = '';
  var attribute = initialAttribute;
  if (initialAttribute === 'class') {
    attribute = '.%s';
  }
  if (initialAttribute === 'data') {
    attribute = '[data-%s]';
  }
  if (attribute.startsWith('.')) {
    var selector = attribute.substring(1);
    setter += "".concat(colorSchemeNode, ".classList.remove('").concat(selector, "'.replace('%s', light), '").concat(selector, "'.replace('%s', dark));\n      ").concat(colorSchemeNode, ".classList.add('").concat(selector, "'.replace('%s', colorScheme));");
  }
  var matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
  if (matches) {
    var _matches$1$split = matches[1].split('='),
      _matches$1$split2 = _slicedToArray(_matches$1$split, 2),
      attr = _matches$1$split2[0],
      value = _matches$1$split2[1];
    if (!value) {
      setter += "".concat(colorSchemeNode, ".removeAttribute('").concat(attr, "'.replace('%s', light));\n      ").concat(colorSchemeNode, ".removeAttribute('").concat(attr, "'.replace('%s', dark));");
    }
    setter += "\n      ".concat(colorSchemeNode, ".setAttribute('").concat(attr, "'.replace('%s', colorScheme), ").concat(value ? "".concat(value, ".replace('%s', colorScheme)") : '""', ");");
  } else {
    setter += "".concat(colorSchemeNode, ".setAttribute('").concat(attribute, "', colorScheme);");
  }
  return /*#__PURE__*/_jsx("script", {
    suppressHydrationWarning: true,
    nonce: typeof window === 'undefined' ? nonce : ''
    // eslint-disable-next-line react/no-danger
    ,

    dangerouslySetInnerHTML: {
      __html: "(function() {\ntry {\n  var mode = localStorage.getItem('".concat(modeStorageKey, "') || 'system';\n  var colorScheme = '';\n  var dark = localStorage.getItem('").concat(colorSchemeStorageKey, "-dark') || '").concat(defaultDarkColorScheme, "';\n  var light = localStorage.getItem('").concat(colorSchemeStorageKey, "-light') || '").concat(defaultLightColorScheme, "';\n  if (mode === 'system') {\n    // handle system mode\n    var mql = window.matchMedia('(prefers-color-scheme: dark)');\n    if (mql.matches) {\n      colorScheme = dark\n    } else {\n      colorScheme = light\n    }\n  }\n  if (mode === 'light') {\n    colorScheme = light;\n  }\n  if (mode === 'dark') {\n    colorScheme = dark;\n  }\n  if (colorScheme) {\n    ").concat(setter, "\n  }\n} catch(e){}})();")
    }
  }, "mui-color-scheme-init");
}